import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  AppBar,
  Box,
  IconButton,
  Drawer,
  makeStyles,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
} from '@material-ui/core'
import { Link, NavLink } from 'react-router-dom'
import { ReactComponent as HeaderLogo } from '../assets/headernav.svg'
import { ReactComponent as MobileLogo } from '../assets/mobilenav.svg'
import PersonIcon from '@material-ui/icons/Person'
import MenuIcon from '@material-ui/icons/Menu'
import CloseIcon from '@material-ui/icons/Close'
import clsx from 'clsx'
import * as actions from '../actionTypes'

const useStyles = makeStyles((theme) => ({
  // appBar styles ensure menu sits above progress indicator during searches
  appBar: {
    position: 'relative',
    zIndex: 4,
  },
  toolBar: {
    display: `flex`,
    width: `100%`,
    margin: `0 auto`,
    maxWidth: `1620px`,
  },
  fillerBox: {
    flex: 3,
  },
  headerLogo: {
    display: `none`,
    height: `1.75rem`,
    width: `auto`,
    [theme.breakpoints.up('md')]: {
      display: `flex`,
    },
    [theme.breakpoints.up('lg')]: {
      height: `2.25rem`,
    },
  },
  linkContainer: {
    alignItems: `center`,
    display: `none`,
    flex: 3,
    justifyContent: `flex-end`,
    [theme.breakpoints.up('md')]: {
      display: `flex`,
    },
  },
  link: {
    cursor: `pointer`,
    color: `white`,
    fontSize: `0.75rem`,
    marginRight: `1rem`,
    textDecoration: `none`,
    [theme.breakpoints.up('md')]: {
      fontSize: `0.75rem`,
      marginRight: `2rem`,
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: `1rem`,
    },
  },
  activeLink: {
    borderBottom: `2px solid white`,
    cursor: 'default',
    marginTop: `2px`,
    padding: `0.25rem 0`,
  },
  initials: {
    alignItems: `center`,
    backgroundColor: `white`,
    borderRadius: `50%`,
    color: `black`,
    cursor: `pointer`,
    display: `flex`,
    flex: `0 0 auto`,
    height: `2.3125rem`,
    justifyContent: `center`,
    lineHeight: `0.875rem`,
    padding: `0.5rem`,
    width: `2.3125rem`,
  },
  logoutMenu: {
    top: `4.125rem !important`,
  },
  menuButton: {
    display: `flex`,
    fontSize: theme.typography.pxToRem(40),
    [theme.breakpoints.up('md')]: {
      display: `none`,
    },
  },
  title: {
    color: `white`,
    display: `none`,
    flex: `1 1 auto`,
    fontWeight: `700`,
    fontSize: `1.5rem`,
    justifyContent: `center`,
    [theme.breakpoints.up('md')]: {
      display: `flex`,
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: `2rem`,
    },
  },
  titleLink: {
    textDecoration: `none`,
  },
  drawer: {
    [theme.breakpoints.up('md')]: {
      display: `none`,
    },
  },
  drawerPaper: {
    backgroundColor: `rgb(30, 37, 83)`,
    display: `flex`,
    flexDirection: `column`,
  },
  closeBox: {
    color: `white`,
    display: `flex`,
    justifyContent: `flex-end`,
    paddingBottom: `3rem`,
  },
  closeButton: {
    padding: `1.875rem 1.5625rem 0 0`,
  },
  titleDrawer: {
    color: `white`,
    fontWeight: `700`,
    fontSize: `1.9375rem`,
    margin: `0 1.5rem 2rem 1rem`,
    padding: `0 1rem`,
    [theme.breakpoints.up('lg')]: {
      fontSize: `2rem`,
    },
  },
  linkContainerDrawer: {
    display: `flex`,
    flexDirection: `column`,
    margin: `0 1.5rem 0 1rem`,
    minWidth: `298px`,
  },
  linkDrawer: {
    cursor: `pointer`,
    color: `white`,
    fontSize: `1.25rem`,
    padding: `0.75rem 1.25rem`,
    textDecoration: `none`,
    width: `100%`,
  },
  activeLinkDrawer: {
    backgroundColor: `white`,
    borderRadius: `0.25rem`,
    color: `rgb(30, 37, 83)`,
    padding: `1rem`,
  },
  initialsDrawer: {
    alignItems: `center`,
    backgroundColor: `white`,
    borderRadius: `50%`,
    color: `black`,
    display: `flex`,
    flex: `0 0 auto`,
    height: `2.3125rem`,
    justifyContent: `center`,
    lineHeight: `0.875rem`,
    margin: `0.75rem 1.25rem`,
    padding: `0.5rem`,
    width: `2.3125rem`,
  },
  MobileLogo: {
    height: `4rem`,
    margin: `auto 0 7rem 2.25rem`,
  },
}))


function NavBar() {
  const classes = useStyles()
  const dispatch = useDispatch()

  const { isAuthenticated } = useSelector((state) => state.authentication)

  const [drawerOpen, setDrawerOpen] = useState(false)

  const [anchorEl, setAnchorEl] = useState(null)
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  const onLogout = () => {
    dispatch({ type: actions.LOGOUT_REQUEST })
    dispatch({ type: actions.RESET_REDUX })
    setDrawerOpen(false)
    handleClose()
  }


  return (
    <AppBar className={classes.appBar}>
      <Toolbar className={classes.toolBar}>
        <Box className={classes.fillerBox}>
          {isAuthenticated && (
            <IconButton
              className={clsx(classes.menuButton, drawerOpen && classes.hide)}
              color="inherit"
              aria-label="open drawer"
              onClick={() => setDrawerOpen(true)}
              edge="start"
            >
              <MenuIcon />
            </IconButton>
          )}
          <HeaderLogo className={classes.headerLogo} />
        </Box>
        <Link to="/" className={classes.titleLink}>
          <Typography className={classes.title}>JeffQuest</Typography>
        </Link>
        {isAuthenticated ? (
          <Typography component={`nav`} className={classes.linkContainer}>
            <NavLink
              activeClassName={classes.activeLink}
              exact
              to="/"
              className={classes.link}
            >
              Project Board
            </NavLink>
            <NavLink
              activeClassName={classes.activeLink}
              to="/submission"
              className={classes.link}
            >
              Submit Project
            </NavLink>
            
            <NavLink
              activeClassName={classes.activeLink}
              to="/about"
              className={classes.link}
            >
              About
            </NavLink>
            <Typography className={classes.initials} onClick={handleClick}>
              <PersonIcon />
            </Typography>
            <Menu
              classes={{ paper: classes.logoutMenu }}
              id="simple-menu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              <MenuItem onClick={onLogout}>Logout</MenuItem>
            </Menu>
          </Typography>
        ) : (
            <Typography component={`nav`} className={classes.linkContainer}></Typography>
          )}
      </Toolbar>
      <Drawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        classes={{ root: classes.drawer, paper: classes.drawerPaper }}
      >
        <Box className={classes.closeBox}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={() => setDrawerOpen(false)}
            edge="start"
            className={classes.closeButton}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <Link to="/" className={classes.titleLink} onClick={() => setDrawerOpen(false)}>
          <Typography className={classes.titleDrawer}>JeffQuest</Typography>
        </Link>
        <Typography component={`nav`} className={classes.linkContainerDrawer}>
          <NavLink
            activeClassName={classes.activeLinkDrawer}
            className={classes.linkDrawer}
            exact
            onClick={() => setDrawerOpen(false)}
            to="/"
          >
            Project Board
          </NavLink>

          <NavLink
            activeClassName={classes.activeLinkDrawer}
            className={classes.linkDrawer}
            onClick={() => setDrawerOpen(false)}
            to="/submission"
          >
            Submit Project
          </NavLink>
          
          <NavLink
            activeClassName={classes.activeLinkDrawer}
            className={classes.linkDrawer}
            onClick={() => setDrawerOpen(false)}
            to="/about"
          >
            About
          </NavLink>

          <div className={classes.linkDrawer} onClick={onLogout}>
            Logout
          </div>
          <Typography className={classes.initialsDrawer}>
            <PersonIcon />
          </Typography>
        </Typography>
        <MobileLogo className={classes.MobileLogo} />
      </Drawer>
    </AppBar>
  )
}

export default NavBar
